import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";
import snapchatIcon from "@/assets/images/icons/snapcaht.svg";
import xIcon from "@/assets/images/icons/x.svg";
import instagramIcon from "@/assets/images/icons/instagram.svg";
import facebookIcon from "@/assets/images/icons/facebook.svg";
import tiktokIcon from "@/assets/images/icons/tiktok.svg";
import { useRouter } from "vue-router";
import { useGeneralStore } from "@/store/General";
export const publishPost = defineStore("publishPost", {
  state: () => ({
    useGeneralStore: useGeneralStore(),
    storyContant: false,
    mediaFilsPost: [],
    facebookPostMedia: [],
    instagramPostMedia: [],
    tikTokPostMedia: [],
    snapChatPostMedia: [],
    facebookStoryMedia: [],
    facebookReelMedia: [],
    instagramStoryMedia: [],
    instagramReelMedia: [],
    tikTokStoryMedia: [],
    snapchatStoryMedia: [],
    snapChatReelMedia: [],
    selectedFacebookTypes: [],
    selectedInstgramTypes: [],
    boostYourPost: false,
    secdate: null,
    xPostMedia: [],
    xPostMedia: [],
    allMediaFils: [],
    post: {
      facebook: [],
      instagram: [],
      tiktok: [],
      snapchat: [],
      x: [],
    },
    errors: [],
    comment: "",
    commentImages: [],
    boost: {
      facebook: {
        state: false,
        id: 15,
        icon: facebookIcon,
        ad_account_id: "",
        page_id: "",
        objective: "",
        lifetime_budget: "",
        special_ad_categories: "",
        start_time: "",
        end_time: "",
        targeting: {
          geo_locations: {
            countries: [""],
            regions: [""],
            radius: "",
            distance_unit: "",
          },
        },
        genders: "",
        age_max: "",
        age_min: "",
        publisher_platforms: null,
        flexible_spec: {
          interests: {
            id: "",
            name: "",
          },
        },
      },

      instagram: {
        state: false,
        budget: "",
        duration: "",
        currency: "EG",
        icon: instagramIcon,
        id: 35,
      },
      tiktok: {
        state: false,
        budget: "",
        duration: "",
        currency: "EG",
        icon: tiktokIcon,
        id: 25,
      },
      snapchat: {
        state: false,
        budget: "",
        duration: "",
        currency: "EG",
        icon: snapchatIcon,
        id: 45,
      },
      x: {
        state: false,
        budget: "",
        duration: "",
        currency: "EG",
        icon: xIcon,
        id: 55,
      },
      loading: false,
    },
    pagesIds: [],
    pages: [],
  }),
  getters: {
    getSelectedTypes() {
      let selectedTypes = [];
      Object.keys(this.post).forEach((key) => {
        if (Array.isArray(this.post[key])) {
          selectedTypes[key] = [];
          this.post[key].forEach((entry) => {
            selectedTypes[key].push(entry.type);
          });
        }
      });
      return selectedTypes;
    },
    getPost() {
      return this.post;
    },
    getCarouselSlider() {
      return Object.entries(this.post).flatMap(([platform, features]) => {
        return features.map((item) => ({
          platform,
          type: item.type,
        }));
      });
    },
  },
  actions: {
    updateStoryContant() {
      this.storyContant = !this.storyContant;
    },
    UpdatePlatformTypes(platformsfor, platform, typeKeys) {
      // Initialize platform array if it doesn't exist
      if (!this.post[platform] || !Array.isArray(this.post[platform])) {
        this.post[platform] = [];
      }

      const existingTypes = new Map(
        this.post[platform].map((item) => [item.type, item])
      );

      // Normalize typeKeys - handle both string and object formats
      const normalizedTypeKeys = typeKeys.map((type) => {
        if (typeof type === 'string') {
          return type;
        } else if (type && typeof type === 'object') {
          return type.id || type.value || type.type || String(type);
        }
        return String(type);
      });

      const updatedEntries = normalizedTypeKeys.map((type) => {
        if (existingTypes.has(type)) {
          return existingTypes.get(type);
        } else {
          if (platformsfor === "customize") {
            return { type, content: "", url: "", comment: "", file: "" };
          } else if (platformsfor === "all") {
            let firstValidEntry = null;
            for (const key in this.post) {
              if (this.post[key] && Array.isArray(this.post[key])) {
                firstValidEntry = this.post[key].find(
                  (item) => item.content && item.url
                );
                if (firstValidEntry) break;
              }
            }
            if (firstValidEntry) {
              return {
                type,
                content: firstValidEntry.content,
                url: firstValidEntry.url,
              };
            } else {
              return { type, content: "", url: "", comment: "", file: "" };
            }
          }
        }
      });

      this.post[platform] = updatedEntries;
      console.log(`Updated ${platform} types:`, this.post[platform]);
    },
    UpdatePlatformContents(
      platformsfor,
      platform = null,
      typeKey = null,
      content
    ) {
      // Debug logging
      console.log('UpdatePlatformContents called:', {
        platformsfor,
        platform,
        typeKey,
        content: content?.substring(0, 50) + (content?.length > 50 ? '...' : ''),
        contentLength: content?.length
      });
      
      if (platformsfor === "customize") {
        if (platform) {
          if (this.post[platform] && Array.isArray(this.post[platform])) {
            if (typeKey) {
              const entry = this.post[platform].find(
                (item) => item.type === typeKey
              );
              if (entry) {
                entry.content = content;
                console.log(`Updated ${platform} ${typeKey} content:`, entry);
              } else {
                console.warn(
                  `No entry found with type '${typeKey}' in platform '${platform}'`
                );
              }
            } else {
              this.post[platform].forEach((entry) => {
                entry.content = content;
              });
              console.log(`Updated all entries in ${platform}:`, this.post[platform]);
            }
          } else {
            console.error(`Invalid platform: ${platform}`);
          }
        } else if (typeKey) {
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                if (entry.type === typeKey) {
                  entry.content = content;
                }
              });
            }
          });
          console.log(`Updated all ${typeKey} entries across platforms`);
        } else {
          // If both platform and typeKey are empty in customize mode, 
          // fall back to updating all platforms (same as "all" mode)
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                entry.content = content;
              });
            }
          });
          console.log('Updated all platforms (customize fallback):', this.post);
        }
      } else {
        Object.keys(this.post).forEach((key) => {
          if (Array.isArray(this.post[key])) {
            this.post[key].forEach((entry) => {
              entry.content = content;
            });
          }
        });
        console.log('Updated all platforms (all mode):', this.post);
      }
    },
    UpdatePlatformLinks(
      platformsfor,
      platform = null,
      typeKey = null,
      url,
      name = null
    ) {
      if (platformsfor === "customize") {
        if (platform) {
          if (this.post[platform] && Array.isArray(this.post[platform])) {
            if (typeKey) {
              const entry = this.post[platform].find(
                (item) => item.type === typeKey
              );
              if (entry) {
                entry.url = url;
                entry.url_name = name;
              } else {
              }
            } else {
              this.post[platform].forEach((entry) => {
                entry.url = url;
                entry.url_name = name;
              });
            }
          } else {
            console.error(`Invalid platform: ${platform}`);
          }
        } else if (typeKey) {
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                if (entry.type === typeKey) {
                  entry.url = url;
                  entry.url_name = name;
                }
              });
            }
          });
        }
      } else {
        Object.keys(this.post).forEach((key) => {
          if (Array.isArray(this.post[key])) {
            this.post[key].forEach((entry) => {
              entry.url = url;
              entry.url_name = name;
            });
          }
        });
      }
      console.log("this.post", this.post);
    },
    RemovePlatformLinks(platformsfor, platform = null, typeKey = null) {
      if (platformsfor === "customize") {
        if (platform) {
          if (this.post[platform] && Array.isArray(this.post[platform])) {
            if (typeKey) {
              const entry = this.post[platform].find(
                (item) => item.type === typeKey
              );
              if (entry) {
                entry.url = "";
              } else {
              }
            } else {
              this.post[platform].forEach((entry) => {
                entry.url = "";
              });
            }
          } else {
            console.error(`Invalid platform: ${platform}`);
          }
        } else if (typeKey) {
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                if (entry.type === typeKey) {
                  entry.url = "";
                }
              });
            }
          });
        }
      } else {
        Object.keys(this.post).forEach((key) => {
          if (Array.isArray(this.post[key])) {
            this.post[key].forEach((entry) => {
              entry.url = "";
            });
          }
        });
      }
    },
    updatePlatformFile(platformsfor, platform = null, typeKey = null, file) {
      if (platformsfor === "customize") {
        if (platform) {
          if (this.post[platform] && Array.isArray(this.post[platform])) {
            if (typeKey) {
              const entry = this.post[platform].find(
                (item) => item.type === typeKey
              );
              if (entry) {
                entry.file = file;
              } else {
              }
            } else {
              this.post[platform].forEach((entry) => {
                entry.file = file;
              });
            }
          } else {
            console.error(`Invalid platform: ${platform}`);
          }
        } else if (typeKey) {
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                if (entry.type === typeKey) {
                  entry.file = file;
                }
              });
            }
          });
        }
      } else {
        const allEmpty = Object.keys(this.post).every(
          (key) => Array.isArray(this.post[key]) && this.post[key].length === 0
        );
        if (allEmpty) {
          this.post["facebook"].push({
            type: "",
            content: "",
            url: "",
            file: file,
            comment: "",
          });
        } else {
          Object.keys(this.post).forEach((key) => {
            if (Array.isArray(this.post[key])) {
              this.post[key].forEach((entry) => {
                entry.file = file;
              });
            }
          });
        }
      }
    },
    validation() {
      this.errors = [];
      if (this.post.facebook) {
        this.post.facebook.forEach((item, index) => {
          if (!["post", "reel"].includes(item.type)) {
            this.errors.push(
              `Facebook post ${
                index + 1
              }: Type must be one of post, reel, or story.`
            );
          }
          if (item.type === "post") {
            // Debug logging
            console.log(`Facebook post ${index + 1} validation:`, {
              content: item.content,
              contentType: typeof item.content,
              contentLength: item.content?.length,
              trimmedLength: item.content?.trim()?.length,
              fullItem: item
            });
            
            if (
              !item.content ||
              typeof item.content !== 'string' ||
              item.content.trim().length < 2
            ) {
              this.errors.push(
                `Facebook post ${
                  index + 1
                }: Message must be at least 2 characters.`
              );
            }
          }
          // if (
          //   item.type === "post" &&
          //   (!item.url || item.url.length < 2 || item.url.length > 255)
          // ) {
          //   this.errors.push(
          //     `Facebook post ${
          //       index + 1
          //     }: Link must be between 2 and 255 characters.`
          //   );
          // }
          if (item.type === "reel" && !item.file) {
            this.errors.push(
              `Facebook reel ${index + 1}: File must be a valid MP4 file.`
            );
          }
          if (
            item.type === "reel" &&
            (!item.content ||
              typeof item.content !== 'string' ||
              item.content.trim().length < 2)
          ) {
            this.errors.push(
              `Facebook reel ${
                index + 1
              }: Description must be at least 2 characters.`
            );
          }
          // if (item.type && !item.page_id) {
          //   this.errors.push(`Facebook Page ID is required.`);
          // }
        });
      }

      if (this.post.instagram) {
        this.post.instagram.forEach((item, index) => {
          if (!["post", "reel", "story"].includes(item.type)) {
            this.errors.push(
              `Instagram post ${
                index + 1
              }: Type must be one of post, reel, or story.`
            );
          }
          if (
            item.type === "post" &&
            (!item.content ||
              typeof item.content !== 'string' ||
              item.content.trim().length < 2)
          ) {
            this.errors.push(
              `Instagram post ${
                index + 1
              }: Caption must be at least 2 characters.`
            );
          }
          if (item.type === "post") {
            // Check if file is a string URL or an object with file property
            const hasFile = item.file && (
              (typeof item.file === 'string' && item.file.length >= 2 && item.file.length <= 255) ||
              (typeof item.file === 'object' && (item.file.file || item.file.url))
            );
            if (!hasFile) {
              this.errors.push(
                `Instagram post ${
                  index + 1
                }: Image is required. Please upload an image file.`
              );
            }
          }
          if (item.type === "reel") {
            // this.errors.push(
            //   `Instagram reel ${index + 1}: Video URL must be a valid MP4 file.`
            // );
          }
          if (
            item.type === "reel" &&
            (!item.content ||
              typeof item.content !== 'string' ||
              item.content.trim().length < 2)
          ) {
            this.errors.push(
              `Instagram reel ${
                index + 1
              }: Caption must be at least 2 characters.`
            );
          }
        });
      }
      if (this.errors.length > 0) {
        console.error("Validation Errors:", this.errors);
      } else {
        console.log("Validation passed!");
      }
    },
    getLink(platform, typeKey) {
      if (platform) {
        if (typeKey === "story_and_reel") {
          let links = [];
          let entryreel = this.post[platform].find(
            (item) => item.type === "reel"
          );
          if (entry) {
            entry.url
              ? links.push({ href: entry.url, name: entry.url_name })
              : null;
          }
          let entrystory = this.post[platform].find(
            (item) => item.type === "story"
          );
          if (entrystory) {
            entry.url
              ? links.push({ href: entry.url, name: entry.url_name })
              : null;
          }
          return links;
        } else {
          if (typeKey) {
            console.log(this.post);

            const entry = this.post[platform].find(
              (item) => item.type === typeKey
            );
            if (entry) {
              return entry.url
                ? [{ href: entry.url, name: entry.url_name }]
                : [];
            }
          } else {
            this.post[platform].forEach((entry) => {
              return entry.url
                ? [{ href: entry.url, name: entry.url_name }]
                : [];
            });
          }
        }
      } else if (typeKey) {
        let links = [];
        Object.keys(this.post).forEach((key) => {
          if (Array.isArray(this.post[key])) {
            this.post[key].forEach((entry) => {
              if (entry.type === typeKey) {
                entry.url
                  ? links.push({ href: entry.url, name: entry.url_name })
                  : null;
              }
            });
          }
        });
        return links;
      }
    },
    getPages() {
      let platforms = [];
      if (this.selectedFacebookTypes.length > 0) {
        platforms.push("facebook");
      }
      if (this.selectedInstgramTypes.length > 0) {
        platforms.push("instagram");
      }
      apiClient
        .get("/all-platfroms-pages", {
          params: {
            platforms: platforms,
          },
        })
        .then((response) => {
          this.pages = response.data.data;
        });
    },
    uploadFile(file) {
      return new Promise((resolve, reject) => {
        apiClient
          .post("/publish-posts/upload/file", {
            file: file,
          })
          .then((response) => {
            console.log(response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            reject(error);
          });
      });
    },

    async formattedRequestToSend() {
      const formData = new FormData();

      for (const platform of Object.keys(this.post)) {
        for (const item of this.post[platform]) {
          const pages = this.pagesIds.filter((p) => p.platform === platform);

          for (const page of pages) {
            const keyPrefix = `${item.type}_${platform}`; // مثال: post_facebook

            formData.append(`${keyPrefix}_page_id`, page.id);

            if (item.type === "post") {
              formData.append(`${keyPrefix}_message`, item.content || "");
              formData.append(`${keyPrefix}_link`, item.url || "");

              if (item.file?.file) {
                formData.append(`${keyPrefix}_url`, item.file.file);
              }
            }

            if (item.type === "reel") {
              formData.append(`${keyPrefix}_description`, item.content || "");
              if (item.file?.file) {
                formData.append(`${keyPrefix}_file`, item.file.file);
              }
            }

            if (item.type === "story") {
              formData.append(`${keyPrefix}_caption`, item.content || "");
              if (item.file?.file) {
                formData.append(`${keyPrefix}_video_url`, item.file.file);
              }
            }
          }
        }
      }

      return formData;
    },
    goNextRoute() {
      const router = useRouter();
      console.log(this.boost);
      router.push({ name: "BoostPost" });
    },
    formatDateForBackend(dateInput) {
      if (!dateInput) return "";

      const date = new Date(dateInput);

      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const hours = ("0" + date.getHours()).slice(-2);
      const minutes = ("0" + date.getMinutes()).slice(-2);
      const seconds = ("0" + date.getSeconds()).slice(-2);

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    createNewAudience() {
      try {
        const adAccountId =
          localStorage.getItem("meta_ad_account_id_boost_post") || "";
        const pageId = localStorage.getItem("pageIdBoostPost") || "";
        const objective =
          localStorage.getItem("selected_objective_boost_post") || "";
        const endTimeString =
          localStorage.getItem("meta_end_time_boost_post") || "";
        const endTime = endTimeString ? new Date(endTimeString) : null;

        let specialAdCategories = [];
        try {
          specialAdCategories = JSON.parse(
            localStorage.getItem("meta_special_ad_categories_boost_post") ||
              "['NONE']"
          );
        } catch (error) {
          console.error("Failed to parse special_ad_categories:", error);
        }

        let genders = [];
        try {
          genders = JSON.parse(
            localStorage.getItem("boost_post_selected_gender") || "[]"
          );
        } catch (error) {
          console.error("Failed to parse genders:", error);
        }

        const ageMax = Number(localStorage.getItem("max_range_age")) || null;
        const ageMin = Number(localStorage.getItem("min_range_age")) || null;
        const budget =
          Number(localStorage.getItem("max_range_life_time")) || null;

        // 🔥 Detect if it's a Special Ad Category
        const isSpecialCategory = specialAdCategories.some((cat) =>
          ["HOUSING", "EMPLOYMENT", "CREDIT"].includes(cat.toUpperCase())
        );

        const geoLocations = isSpecialCategory
          ? { countries: ["US"] }
          : {
              countries: ["US"],
              // regions: [{ key: "1001" }],
              // cities: [{ key: "658536" }],
            };

        const audienceData = {
          facebook: {
            ad_account_id: adAccountId,
            page_id: pageId,
            objective: objective,
            special_ad_categories: ["NONE"],
            start_time: new Date().toISOString(),
            end_time: endTime,
            lifetime_budget: budget,
            targeting: {
              geo_locations: geoLocations,
              genders: genders,
              age_max: ageMax,
              age_min: ageMin,
              publisher_platforms: ["facebook"],

              // flexible_spec: [
              //   {
              //     interests: [
              //       {
              //         id: "6002925969459",
              //         name: "watching movies",
              //       },
              //     ],
              //   },
              // ],
            },
          },
        };

        // 📢 Log for Debugging
        console.log("Special Ad Categories:", specialAdCategories);
        console.log("Geo Locations:", JSON.stringify(geoLocations, null, 2));

        return audienceData;
      } catch (error) {
        console.error("Error creating audience:", error);
        throw error;
      }
    },
    async SendPostToPublish() {
      // console.log("assssd",this.commentImages);
      this.useGeneralStore.ShowLoading(true);
      this.validation();
      if (this.errors.length > 0) {
        this.useGeneralStore.HideLoading();
        this.useGeneralStore.showSnackbar(
          `Please fix ${this.errors.length} validation error${this.errors.length > 1 ? 's' : ''} before publishing.`,
          "error"
        );
        return;
      }
      try {
        const formData = new FormData();
        for (const platform of Object.keys(this.post)) {
          for (const item of this.post[platform]) {
            const pages = this.pagesIds.filter((p) => p.platform === platform);
            for (const page of pages) {
              // ✅ Facebook Post
              if (platform === "facebook" && item.type === "post") {
                formData.append("post_facebook_page_id", page.id);
                formData.append("post_facebook_message", item.content || "");
                formData.append("post_facebook_link", item.url || "");
                formData.append("post_facebook_comment", this.comment || "");
                formData.append(
                  "schedule_time",
                  this.formatDateForBackend(this.secdate) || ""
                );
                if (item.file?.file) {
                  formData.append("post_facebook_url", item.file.file || null );
                }
                formData.append("post_facebook_comment_photo", this.commentImages[0]?.file || "");
              }

              // ✅ Facebook Reel
              if (platform === "facebook" && item.type === "reel") {
                formData.append("reel_facebook_page_id", page.id);
                formData.append("reel_facebook_comment", this.comment || "");
                formData.append(
                  "reel_facebook_description",
                  item.content || ""
                );
                formData.append(
                  "schedule_time",
                  this.formatDateForBackend(this.secdate) || ""
                );
                if (item.file?.file) {
                  formData.append("reel_facebook_file", item.file.file);
                }
                formData.append("reel_facebook_comment_photo", this.commentImages[0]?.file || "");
              }

              // ✅ Instagram Post
              if (platform === "instagram" && item.type === "post") {
                formData.append("post_instagram_page_id", page.id);
                formData.append("post_instagram_caption", item.content || "");
                formData.append("post_instagram_comment", this.comment || "");
                formData.append(
                  "schedule_time",
                  this.formatDateForBackend(this.secdate) || ""
                );
                if (item.file?.file) {
                  formData.append("post_instagram_image_url", item.file.file);
                }
                formData.append("post_instagram_comment_photo", this.commentImages[0]?.file || "");
              }

              // ✅ Instagram Reel
              if (platform === "instagram" && item.type === "reel") {
                formData.append("reel_instagram_page_id", page.id);
                formData.append("reel_instagram_caption", item.content || "");
                formData.append("reel_instagram_comment", this.comment || "");
                formData.append(
                  "schedule_time",
                  this.formatDateForBackend(this.secdate) || ""
                );
                if (item.file?.file) {
                  formData.append("reel_instagram_video_url", item.file.file);
                }
                formData.append("reel_instagram_comment_photo", this.commentImages[0]?.file || "");
              }

              // ✅ Instagram Story
              if (platform === "instagram" && item.type === "story") {
                formData.append("story_instagram_page_id", page.id);
                formData.append("story_instagram_caption", item.content || "");
                formData.append(
                  "schedule_time",
                  this.formatDateForBackend(this.secdate) || ""
                );
                if (item.file?.file) {
                  formData.append("story_instagram_video_url", item.file.file);
                }
              }
              // ✅ باقي المنصات لاحقاً (TikTok, Snapchat, X) حسب نفس النمط
            }
          }
        }
        // ✅ Boost Data
        if (this.boostYourPost) {
          const boost = this.createNewAudience();

          formData.append(
            "boost_facebook_ad_account_id",
            boost.facebook.ad_account_id
          );
          formData.append("boost_facebook_page_id", boost.facebook.page_id);
          formData.append("boost_facebook_objective", boost.facebook.objective);
          formData.append(
            "boost_facebook_special_ad_categories",
            boost.facebook.special_ad_categories[0]
          );
          formData.append(
            "boost_facebook_start_time",
            boost.facebook.start_time
          );
          formData.append(
            "boost_facebook_geo_country",
            boost.facebook.targeting.geo_locations.countries[0]
          );
          formData.append(
            "boost_facebook_publisher_platforms",
            boost.facebook.targeting.publisher_platforms[0]
          );
        }

        // ✅ Final request
     const response =    await apiClient.post("/publish-posts/create/post", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.useGeneralStore.HideLoading();
        
          
        this.useGeneralStore.showSnackbar(
          "Published successfully",

          "#237276"
        );
        this.post = {
          facebook: [],
          instagram: [],
          tiktok: [],
          snapchat: [],
          x: [],
        };
        this.comment = "";
        this.secdate = null;
        this.boostYourPost = false;
        this.pagesIds = [];
        
      } catch (error) {
        console.error("SendPostToPublish error:", error.response.data.msg);
        this.useGeneralStore.HideLoading();
        this.useGeneralStore.showSnackbar(error.response.data.msg, "error");
      } finally{
    
      
        this.post = {
          facebook: [],
          instagram: [],
          tiktok: [],
          snapchat: [],
          x: [],
        };
        this.comment = "";
        this.secdate = null;
        this.boostYourPost = false;
        this.pagesIds = [];
        this.commentImages = [];
        this.errors = [];
        
      }
    },
  },
});
